module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    ref: "element",
    staticClass: "lit-item"
  }, [(_vm.showLabel) ? [(_vm.label) ? [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")] : [_vm._v("\n      ?\n    ")]] : _vm._e(), _vm._v("\n  " + _vm._s(_vm.formattedLink) + "\n  ")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1958b0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LitListItemView.vue
// module id = 1025
// module chunks = 1